import script from "./AdvertisementDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./AdvertisementDetails.vue?vue&type=script&setup=true&lang=js"

import "./AdvertisementDetails.vue?vue&type=style&index=0&id=ddbaa274&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ddbaa274"]])

export default __exports__